import React, { useState, useEffect } from 'react'
import UpdateForm from './UpdateForm'
import { PageHeader, StatusBadge } from '../../ui'
export default function SupportScreen() {
  const [accessType, setAccessType] = useState('');
  //API call
  useEffect(() => {
  
    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);
  
    if (foundUser.role_capabilities?.all_modules_access === true) {
  
      setAccessType('Edit');
      
    }
    else {
  
      // setAccessType(foundUser.access['FetchConsole_Access Specifier']);
      setAccessType('Edit');
    }
  
  }, []);
  
  return (
    <>
      <PageHeader
        title="Help & Support"
        subtitle="Start a support conversation, review replies, and share the details needed to resolve an issue."
        eyebrow="Support"
      >
        {accessType === 'View' && <StatusBadge status="neutral">View only</StatusBadge>}
      </PageHeader>

            {/* <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button>
            <Modal
              size="lg"
              show={lgShow}
              onHide={() => setLgShow(false)}
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
                <Modal.Title id="example-modal-sizes-title-lg" >
                  Instructions to Add/Edit User
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h5>Create New user</h5>
                <ol>
                  <li>User Setup {'>'} Click on Add New User</li>
                  <li>Select the company from company name dropdown {'>'} Company ID is generated</li>
                  <li>Enter the User Email ID and Name {'>'} User ID is generated</li>
                  <li>From Branch Access select Branch Name {'>'} Click on allocated check box {'>'} All module access is given to the user {'>'} Click on submit</li>
                  <li>To give access to only few modules, click on radio button in the Branch Access {'>'} Module access is generated {'>'} Select modules {'>'} Allocate the access {'>'} Click on submit</li>
                </ol>
                <h5>View/Edit User</h5>
                <ol>
                  <li>To view/edit user ID’s, select company name from drop down {'>'} view/edit the user details {'>'} submit.</li>
                  <li><strong>Note:</strong> Company name and user ID fields are non-editable</li>
                </ol>
                <h5>To deactivate the User</h5>
                <ol>
                  <li>User Setup {'>'} Select company name from drop down.</li>
                  <li>Go to the edit user page.</li>
                  <li>Click on deactivate</li>
                </ol>
              </Modal.Body>
            </Modal> */}
      { accessType === 'View' ? <UpdateForm accessType = { accessType } /> : <UpdateForm /> }
    </>
  );
}
